import React from 'react';

function LandingPage({ children, className = '' }) {
  return <div className={`container landing-page ${className}`.trim()}>{children}</div>;
}

export default LandingPage;
